const EXP_REG = /^[0-9]{1,2}(([hm]{0,1})|( [hm]{0,1}))?(( [0-9]{0,2})|([0-9]{0,2}))?(m h [0-9]{2})?((m)|( m))?$/;

export { EXP_REG };
